import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
/*! modern-normalize v1.1.0 | MIT License | https://github.com/sindresorhus/modern-normalize */
 

body{
	position: relative;
}
.gm-style-iw > button {
	display: none !important;
}

html, body, #root {
	width:100%;
	height:100%;
	overflow: hidden;
	margin:0;
	-webkit-print-color-adjust: exact;
    -webkit-filter: opacity(1);
	
}

#root{
	display:flex;
	flex-flow: column;	
}

.SnackbarContainer-root {
  z-index: 9999 !important;
}

.dialog-component {
  z-index: 999;
}
 
`;

export default GlobalStyle;
